<section class="py-5" style="background: linear-gradient(135deg, #f1f5f9 60%, #e0e7ff 100%); min-height: 100vh;">
    <div class="container">
        <div class="row justify-content-center align-items-center" style="min-height: 60vh;">
            <div class="col-md-9 col-lg-7">
                <div class="card shadow-lg border-0 rounded-4 p-5" style="background: rgba(255,255,255,0.96);">
                    <div class="text-center mb-4">
                        <div class="mx-auto mb-3 d-flex align-items-center justify-content-center" style="width: 72px; height: 72px; background: linear-gradient(135deg, #fbbf24 70%, #6366f1 100%); border-radius: 50%;">
                            <i class="fa fa-university fa-2x text-white"></i>
                        </div>
                        <h2 class="fw-bold mb-2" style="letter-spacing: -.5px;">Zahlung erforderlich: Banküberweisung</h2>
                        <p class="lead text-secondary mb-1">
                            Ihre Bestellung ist bei uns eingegangen.
                        </p>
                        <p class="text-muted">
                            Bitte schließen Sie die Zahlung per <strong>Banküberweisung</strong> ab, um Ihre Bestellung zu finalisieren.
                        </p>
                        <p class="mt-3">
                            <span class="fw-semibold text-primary">Alle Zahlungsinformationen wurden gesendet an:</span><br>
                            <span><strong>{{ email }}</strong></span>
                        </p>
                    </div>

                    <div class="text-center mb-4">
                        <h5 class="fw-semibold mb-2 text-dark">Wie geht es weiter?</h5>
                        <p class="mb-2">
                            Bitte prüfen Sie Ihre E-Mails auf alle nötigen Zahlungsanweisungen. Sobald Ihre Überweisung bei uns eingeht, erhalten Sie Zugriff auf Ihre gekauften Daten.
                        </p>
                        <p class="mb-0 text-muted small">
                            E-Mail nicht gefunden? Überprüfen Sie auch Ihren Spam- oder Junk-Ordner.
                        </p>
                    </div>

                    <div class="d-grid gap-2">
                        <button class="btn btn-gradient-primary btn-lg rounded-pill fw-semibold" (click)="onCreateAccount()">
                            <i class="fa fa-user-plus me-2"></i> Jetzt Account anlegen
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
